module.exports = __webpack_public_path__ + "img/img_tishi@2x2.f17f91ab.png";